import React, {Component, Fragment} from "react";
import 'chart.js/auto';
import {Bar} from 'react-chartjs-2';
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import {getMessage} from "./util";

class VotesByTimeSlot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            votes: null,
            loading: false
        };
    }

    componentDidMount() {
        this.loadVotesByTimeSlot(this.props.election_id);
    }

    loadVotesByTimeSlot = election_id => {
        this.setState({loading: true}, () =>
            axios({
                method: "get",
                url:
                    process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    this.props.election_id +
                    "/votesByTimeSlot.json"
            })
                .then(response => {
                    this.setState({
                        loading: false,
                        votes: Object.entries(response.data.time_slot).map(function (v) {
                            return {x: 1000 * parseInt(v[0]), y: v[1].electronic_voted};
                        })
                    });
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        axios({
                            method: "get",
                            url:
                                process.env.REACT_APP_API_URL +
                                "/election/" +
                                election_id +
                                "/votesByTimeSlot"
                        })
                            .then(response => {
                                this.setState({
                                    loading: false,
                                    votes: Object.entries(response.data.time_slot).map(function (v) {
                                        return {
                                            x: 1000 * parseInt(v[0]),
                                            y: v[1].electronic_voted
                                        };
                                    })
                                });
                            })
                            .catch(error => {
                                this.setState({loading: false});
                            });
                    } else {
                        this.setState({loading: false});
                    }
                })
        );
    };


    render() {

        const formatter = new Intl.DateTimeFormat('es-es', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        });

        const formatter2 = new Intl.DateTimeFormat('es-es', {
            hour: 'numeric',
            minute: 'numeric'
        });

        const date_format = (date, full) => {
            //tomas: legacy, old elections does not have resolution
            const resolution = this.props.election.configuration.advanced_config.count_votes_resolution_seconds || 3600;
            const since = new Date(date)
            const until = new Date(date + resolution * 1000);
            if (since.getHours() === 0 || full || since.getHours() - (resolution / 3600) < 0) {
                return (formatter.format(since) + " - " + formatter2.format(until))
            } else
                return (formatter2.format(since) + " - " + formatter2.format(until))
        }


        if (this.state.votes === null) {
            return <div>{this.state.loading && <LoadingSpinner/>}</div>;
        } else {
            const data = {
                labels: [date_format(this.state.votes[0].x, true)].concat(this.state.votes.slice(1).map(v => date_format(v.x))),
                datasets: [
                    {
                        label: "Votos Electrónicos ",
                        backgroundColor: "#C6CCD4",
                        data: this.state.votes.map(v => v.y),

                    }
                ]
            };


            const chartOptions2 = {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                }
            };

            return (
                <Fragment>

                    {this.state.votesByTimeSlot !== null && (
                        <Fragment>


                            <div className="row justify-content-center EvColor text-white">
                                <div className="col-12 col-sm-11 col-md-9 col-lg-7  p-3">
                                    <h4>{getMessage('votes_time_slot_title', this.props.messages)}</h4>
                                </div>
                            </div>
                            <br/>
                            <div className="row justify-content-center ">
                                <div className="col-12 col-sm-11 col-md-9 col-lg-7 EvColorGrisLight">
                                    <Bar data={data} options={chartOptions2}/>
                                </div>
                            </div>
                        </Fragment>
                    )}
                </Fragment>
            );
        }
    }
}

export default VotesByTimeSlot;